export default __webpack_public_path__ + "img_bknmsg.567db4.svg";